<template>
  <div class="d-flex">
    <v-navigation-drawer
      :value="true"
      relative
      bottom
      permanent
      scrollable
      style="max-height: calc(100vh - 57px); overflow-y: scroll"
      :mini-variant.sync="mini"
    >
      <div class="d-flex pa-2 align-center">
        <v-btn
          v-if="mini"
          icon
          @click.stop="mini = false"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-autocomplete
          v-else
          label="ค้นหา"
          hide-details
          :items="networks"
          clearable
          @change="searchThread"
        >
          <template #append>
            <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-autocomplete>
        <v-btn
          icon
          class="ml-auto mt-auto"
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="d-flex px-2" />
      <v-divider />
      <v-list
        nav
        dense
        value="selectedThread"
        mandatory
      >
        <v-list-item
          v-for="(thread, index) in threads"
          :key="thread.thread_id"
          :input-value="thread.thread_id == active.thread"
          @click="setActiveThread(thread.thread_id)"
        >
          <v-list-item-icon>
            <v-badge
              dot
              bottom
              color="red"
              :value="thread.notifications"
              offset-x="5"
              offset-y="5"
            >
              <v-avatar
                v-if="thread.participant_name"
                color="indigo"
                size="25"
              >
                <span class="white--text text-sm">{{
                  thread.participant_name.substring(0, 1).toUpperCase()
                }}</span>
              </v-avatar>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-if="thread.participant_name">
              {{ thread.participant_name.toUpperCase() }}
            </v-list-item-title>

            <v-list-item-subtitle class="d-flex align-items-baseline">
              <span
                v-if="thread.messages.length > 0"
                class="text-truncate d-inline-block mr-2"
                style="max-width: 120px"
              >{{ thread.messages[thread.messages.length - 1].message }}
              </span>
              —
              {{ $moment(thread.last_message).fromNow() }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <agent-message-list
      id="message-container"
      :messages="active_messages"
      :participant="active.participant"
      :participant_name="active.participant_name"
      :is_loading="is_message_loading"
      :me="agent_id"
      class="flex-fill"
      @fetchNewMessage="fetchNewMessage"
      @messageUpdated="messageUpdated"
    />
  </div>
</template>
<script>
import { findIndex as _findIndex } from 'lodash';
import moment from 'moment-timezone';
import AgentMessageList from './message-list.vue';
import { Echo } from '../../plugins/pusher';

export default {
  name: 'AgentMessenger',
  components: {
    AgentMessageList,
  },
  data() {
    return {
      mini: false,
      data_threads: [
        {
          last_message: new Date(),
          messages: [],
          has_more: true,
          notifications: 0,
        },
      ],
      active: {
        thread: '',
        participant: 0,
        participant_name: 'user',
      },
      is_loading: true,
      is_message_loading: true,
      selectedThread: 0,
      networks: [],
    };
  },
  computed: {
    active_messages() {
      const thread_index = _findIndex(this.data_threads, {
        thread_id: this.active.thread,
      });
      return this.is_message_loading == false
        && this.active.thread
        && this.data_threads[thread_index]
        ? this.data_threads[thread_index].messages.sort((a, b) => (new Date(a.created_at) >= new Date(b.created_at) ? 1 : -1))
        : [];
    },
    threads() {
      return this.data_threads.sort((a, b) => (new Date(a.last_message) >= new Date(b.last_message) ? -1 : 1));
    },
    agent_id() {
      return this.$store.state.user.agent_id;
    },
  },
  mounted() {
    this.mini = window.innerWidth <= 728;
  },
  async created() {
    moment.locale('th');
    this.is_loading = true;
    this.networks = await axios.get('/api/messages/network').then((response) => response.data.map((user) => ({
      text: user.name,
      value: {
        thread_id: `${Math.min(this.agent_id, user.id)}-${Math.max(
          this.agent_id,
          user.id,
        )}`,
        participant: user.id,
        participant_name: user.name,
      },
    })));
    await axios
      .get('/api/messages/threads')
      .then((response) => {
        this.data_threads = response.data.map((t) => ({
          thread_id: t.thread_id,
          participant:
            this.agent_id == t.sender_id ? t.receiver_id : t.sender_id,
          participant_name:
            this.agent_id == t.sender_id ? t.receiver_name : t.sender_name,
          last_message: new Date(t.created_at),
          messages: [],
          message: t.message,
          notifications: 0,
        }));
        this.active = {
          ...this.active,
          ...this.active,
          thread: this.data_threads[0].thread_id,
        };
      })
      .finally(() => {
        this.setActiveThread(this.data_threads[0].thread_id);
        this.is_loading = false;
      });

    Echo.join(`agent.${window.appState.user.agent_id}`).listen(
      'agent-message-received',
      async (m) => {
        const { message } = m;
        const thread_id = `${Math.min(
          parseInt(message.sender_id),
          parseInt(message.receiver_id),
        )}-${Math.max(
          parseInt(message.sender_id),
          parseInt(message.receiver_id),
        )}`;
        const thread_index = _findIndex(this.data_threads, {
          thread_id,
        });
        if (thread_index >= 0) {
          this.$set(this.data_threads, thread_index, {
            thread_id,
            participant:
              this.agent_id == message.sender_id
                ? message.receiver_id
                : message.sender_id,
            participant_name:
              this.agent_id == message.sender_id
                ? message.receiver_name
                : message.sender_name,
            last_message: new Date(message.created_at),
            messages: [...this.data_threads[thread_index].messages, message],
            notifications: 1,
          });
        } else {
          this.data_threads.push({
            thread_id,
            participant:
              this.agent_id == message.sender_id
                ? message.receiver_id
                : message.sender_id,
            participant_name:
              this.agent_id == message.sender_id
                ? message.receiver_name
                : message.sender_name,
            last_message: new Date(message.created_at),
            messages: [message],
            notifications: 1,
          });
        }
        this.messageUpdated();
      },
    );
  },
  methods: {
    async setActiveThread(thread_id) {
      this.$store.commit('notification/ack', {
        type: 'agent-message-received',
      });
      const thread_index = _findIndex(this.data_threads, { thread_id });
      const thread = { ...this.data_threads[thread_index] };
      if (thread_index >= 0) {
        if (thread && thread.messages.length == 0) {
          this.is_message_loading = true;
          await axios
            .post(`/api/messages/agent/with/${thread.participant}`)
            .then((response) => {
              this.data_threads[thread_index] = {
                ...this.data_threads[thread_index],
                messages: response.data,
                has_more: true,
              };
            })
            .finally(() => {
              this.is_message_loading = false;
            });
        }
        this.active = {
          ...this.active,
          participant: thread.participant,
          participant_name: thread.participant_name,
          thread: thread.thread_id,
        };
        this.messageUpdated();
      }
      this.$set(this.data_threads, thread_index, {
        ...this.data_threads[thread_index],
        notifications: 0,
      });
    },

    searchThread(searching) {
      const thread_index = _findIndex(this.data_threads, {
        thread_id: searching.thread_id,
      });
      if (thread_index >= 0) {
        this.setActiveThread(searching.thread_id);
      } else {
        this.data_threads.push({
          has_more: false,
          last_message: new Date(),
          message: undefined,
          messages: [],
          notifications: 0,
          participant: searching.participant,
          participant_name: searching.participant_name,
          thread_id: searching.thread_id,
        });
        this.setActiveThread(searching.thread_id);
      }
    },

    messageUpdated() {
      setTimeout(() => {
        const container = document.getElementById('message-container');
        container.scrollTop = container.scrollHeight;
      }, 10);
    },

    async fetchNewMessage() {
      const thread_index = _findIndex(this.data_threads, {
        thread_id: this.active.thread,
      });
      const thread = { ...this.data_threads[thread_index] };
      if (thread_index >= 0) {
        if (thread.has_more) {
          this.is_message_loading = true;
          await axios
            .post(`/api/messages/agent/with/${this.active.participant}`, {
              lastMessage: thread.messages[0].created_at,
            })
            .then((response) => {
              if (response.data.length > 0) {
                this.data_threads[thread_index] = {
                  ...this.data_threads[thread_index],
                  messages: [
                    ...response.data,
                    ...this.data_threads[thread_index].messages,
                  ],
                };
              } else {
                this.data_threads[thread_index] = {
                  ...this.data_threads[thread_index],
                  has_more: false,
                };
              }
            })
            .finally(() => {
              this.is_message_loading = false;
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#message-container {
  position: relative;
  height: calc(100vh - 57px);
  overflow-y: scroll;
  scroll-behavior: smooth;
}
.active-thread {
  background-color: red;
}
</style>
